import * as yup from 'yup';
import {
  hasSanierungDach,
  hasSanierungElektroleitung,
  hasSanierungHeizungsrohre,
  hasSanierungSanitaerleitung,
  hasSanierungSonstige,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';
import { isDateAfterBaujahr } from '@/features/Sparten/woh/schema/helper';
import { useWohInputStore } from '@/features/Sparten/woh/useInputStore';

export const sanierungenSchema = yup
  .object({
    sanitaerleitungen: yup.boolean().required().default(false),
    sanitaerleitungenJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasSanierungSanitaerleitung(),
        then: yup.number().required().test(isDateAfterBaujahr),
      }),
    elektroleitungen: yup.boolean().required().default(false),
    elektroleitungenJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasSanierungElektroleitung(),
        then: yup.number().required().test(isDateAfterBaujahr),
      }),
    dach: yup.boolean().required().default(false),
    dachJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasSanierungDach(),
        then: yup.number().required().test(isDateAfterBaujahr),
      }),
    heizungsrohre: yup.boolean().required().default(false),
    heizungsrohreJahr: yup
      .number()
      .default(0)
      .when({
        is: () => hasSanierungHeizungsrohre(),
        then: yup.number().required().test(isDateAfterBaujahr),
      }),
    sonstige: yup.boolean().required().default(false),
    sonstigeMemofeld: yup
      .string()
      .default('')
      .when({
        is: () => hasSanierungSonstige(),
        then: yup.string().required(),
      }),
  })
  .test({
    name: 'isRequired',
    message: 'Wenigstens eine Sanierungsart muss ausgewählt sein.',
    test(value) {
      if (!useWohInputStore().sanierung) return true;

      return (
        value.sanitaerleitungen ||
        value.elektroleitungen ||
        value.dach ||
        value.heizungsrohre ||
        value.sonstige
      );
    },
  });
